import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import { getPersistantState, languageConfig } from "@/features/bestillinger";
import nb from "../locales/nb-NO.json";
import nn from "../locales/nn-NO.json";

export const Language = {
  NB_NO: "nb-NO",
  NN_NO: "nn-NO",
} as const;

export const availableLanguages: Language[] = Object.values(Language);

export type Language = (typeof Language)[keyof typeof Language];

const resources = {
  [Language.NB_NO]: { translation: nb },
  [Language.NN_NO]: { translation: nn },
};

const initLang = getPersistantState(
  languageConfig.storageKey,
  languageConfig.storageType,
);

i18next.use(initReactI18next).init({
  lng: initLang || Language.NB_NO,
  resources,
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: true,
  },
});

export default i18next;
